<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-12 text-center main-title">
            <h1>Simulatore</h1>
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="col-md-6 text-center main-title">
            <form [formGroup]="formFiltri">
                <mdb-form-control class="mb-3">
                    <mdb-select formControlName="mesi">
                        <mdb-option *ngFor="let option of mesi" [value]="option.value" (click)="selezionaMese()">{{
                            option.label
                            }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Seleziona il Periodo di analisi</label>
                </mdb-form-control>
            </form>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            Totale Euro: {{totaleEuro | number : '1.2-2'}}
        </div>
    </div>

    <div class="datatable mt-4">
        <h3>Sommario</h3>
        <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
            [dataSource]="tSys" [sort]="sort">
            <thead class="datatable-header">
                <tr>
                    <th *ngFor="let header of headers2" [mdbTableSortHeader]="header" scope="col">
                        {{ header | titlecase }}
                    </th>
                </tr>
            </thead>
            <tbody class="datatable-body">

                <tr *ngFor="let data2 of table.data" scope="row">
                    <td>{{data2.market}}</td>
                    <td>{{data2.punti | number: '1.4-4'}}</td>
                    <td>{{data2.numop}}</td>
                    <td>{{data2.puntiop | number: '1.4-4'}}</td>
                    <td>{{data2.percpos*100 | number: '1.2-2'}} %</td>
                    <td>{{data2.rawal | number: '1.2-2'}}</td>
                    <td>{{data2.euro | number: '1.2-2'}}</td>
                </tr>
            </tbody>
        </table>
    </div>


    <div class="datatable mt-4">
        <h3>Operazioni</h3>
        <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
            [dataSource]="tableData" [sort]="sort">
            <thead class="datatable-header">
                <tr>
                    <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
                        {{ header | titlecase }}
                    </th>
                </tr>
            </thead>
            <tbody class="datatable-body">

                <tr *ngFor="let data of table.data" scope="row">
                    <td>{{data.market}}</td>
                    <td>{{data.verso}}</td>
                    <td id="id_{{data.market}}">{{data.swing}}</td>
                    <td>{{data.dayweek}}</td>
                    <td>{{data.oraopen}}</td>
                    <td>{{data.vopen}}</td>
                    <td>{{data.oraclose}}</td>
                    <td>{{data.profit | number: '1.4-4'}}</td>
                </tr>
            </tbody>
        </table>

    </div>